import React from 'react'

type ImageRenderProps = {
    image: any,
    alt: string,
    width: string,
    height: string
}

const ImageRender = (props : ImageRenderProps) => {
    
    return(
        <img src={props.image} alt={props.alt} width={props.width} height={props.height} />
    );
};

export default ImageRender;